// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"9eeb451c","946":"6e8f624a"}[chunkId] + ".chunk.js";
};